import { render, staticRenderFns } from "./SkeletonInventoryComponent.vue?vue&type=template&id=60fd3b5b&scoped=true&"
import script from "./SkeletonInventoryComponent.vue?vue&type=script&lang=js&"
export * from "./SkeletonInventoryComponent.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonInventoryComponent.vue?vue&type=style&index=0&id=60fd3b5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fd3b5b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
